export default __webpack_public_path__ + "static/media/joindiscord.4e2219a1.png";